import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { TranslateService } from "@ngx-translate/core";
import { merge } from "rxjs";
import { tap } from "rxjs/operators";
import { SharedService } from "src/app/services/sharedService";
import { TasDataSource } from "src/app/services/tasGovTable.datasource";
import { TaxPayerService } from "src/app/services/taxPayer.service";
import { ConfirmationDialogComponent } from "../../dialogs/confirmation-dialog/confirmation-dialog.component";
import { UserService } from "src/app/services/user.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-check-approval",
  templateUrl: "./check-approval.component.html",
  styleUrls: ["./check-approval.component.css"],
})
export class CheckApprovalComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  currentYear: any;
  @Input()
  category: any;
  @Input()
  @Input() type;
  currentNIU: any;
  currentYearInt: any;
  currentUser: any;
  displayedYears = [];
  dataSource: TasDataSource;
  refreshDataSubscription: any;
  subscriptionConfirm: any 
  displayedColumns: string[] = ['checkDate', 'municipalityName', 'status', 'tin', 'companyName', 'amount', 'number', 'action'];
  @Input() company: any;
  filterObject: any;
  loading = { inProgress : true}
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  
  constructor(
    public translate: TranslateService,
    public taxPayerService: TaxPayerService,
    public dialog: MatDialog,
    private sharedService: SharedService,
    public userService: UserService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
        this.displayedColumns = ['checkDate', 'municipalityName', 'status', 'tin', 'companyName', 'source', 'amount', 'number', 'action'];
    }
  }

  async ngOnInit() { 
    this.currentUser = await this.userService.getCurrentUser().toPromise()
    this.dataSource = new TasDataSource(this.taxPayerService);
    this.refreshDataSubscription = this.sharedService.cashPaymentPrintEmitter.subscribe(val => {
      this.taxPayerService.getTaxPayerByNiu('tax-payers', this.currentNIU).subscribe(taxPayer => {
        this.company = taxPayer
        this.dataSource = new TasDataSource(this.taxPayerService);
        this.loadTable()
      })

    })
  }

  ngAfterViewInit() {}

  stringifyWithUTC(obj) {
    return JSON.stringify(obj, (key, value) => {
      if (obj && obj[key] instanceof Date) {
        const utcDateString = new Date(obj[key].getTime() - (obj[key].getTimezoneOffset() * 60000)).toISOString();
        return utcDateString
      }
      return value;
    });
  }
  ngOnDestroy(): void {
    this.refreshDataSubscription && this.refreshDataSubscription.unsubscribe()
  }
  loadTable() {
    this.loading.inProgress = true
    this.dataSource.loadData(
      'payments/checks',
      this.stringifyWithUTC(this.filterObject),
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading
    );
  }
  advancedSearch(filter){
    this.filterObject = { ...filter };

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
 
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
       tap(() => this.loadTable())
    )
      .subscribe();

    this.loadTable();
  }

  toggleCheckDialog(element, action) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: {
        text: action === 'APPROVED' ? 'CHECK.CONFIRM_APPROVE' : 'CHECK.CONFIRM_REJECT',
        emitter: this.sharedService.confirmDialogEmitter,
        obj: element,
        action: action
      }
    });
  
    this.subscriptionConfirm = this.sharedService.confirmDialogEmitter.subscribe(val => {
      if (val) {
        this.taxPayerService.toggleCheck(val, action).subscribe(() => {
          this.loadTable();
          if(action === "APPROVED"){
            let check = {
              "paymentSystem": {
                "key": "check",
                "name": "Check"
              },
              "currency": environment.currency.currencyName,
              "amount": val['amount'],
              "paymentDate": val['checkDate'],
              "tin": val['tin'],
              "companyName": val['companyName'],
              "taxName": val['taxName']
            }
            this.taxPayerService.addBalance(check).subscribe(res => {})
          }
        });
      }
    });
  
    dialogRef.afterClosed().subscribe(() => {
      this.subscriptionConfirm.unsubscribe();
    });
  }
  
  resetAdvancedSearch() {
    this.filterObject = {};
  }

  canSeeButtons() {
    if (this.currentUser) {
      return !['FINANCIAL_MANAGER_ADMINISTRATOR','FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR','MAYOR_TREASURER','CENTRAL_READER','CENTRAL_EDITOR'].includes(this.currentUser.role)
      return true
    }
    return false
  }
  
}
